import React, { useEffect, useState } from 'react'

export function RainbowRangeBasedUpperSemiCircularProgress({ score, size = 200, colorRanges = [] }) {
    const validScore = Math.max(1, Math.min(1000, score));
    const percentage = ((validScore - 1) / (1000 - 1)) * 100;

    // Define color ranges
    /* const colorRanges = [
        { min: 1, max: 599, startColor: 'rgb(235, 16, 16)', endColor: 'rgb(247, 179, 64)', name: "Bajo" },
        { min: 600, max: 700, startColor: 'rgb(250, 160, 7)', endColor: 'rgb(5, 150, 105)', name: "Regular" },
        { min: 701, max: 750, startColor: 'rgb(6, 92, 65)', endColor: 'rgb(6, 92, 65)', name: "Bueno" },
        { min: 751, max: 1000,startColor: 'rgb(16, 185, 129)', endColor: 'rgb(15, 217, 150))',  name: "Excelente" },
    ] */

    const strokeWidth = size / 20
    const radius = (size - strokeWidth) / 2
    const circumference = radius * Math.PI
    const strokeDashoffset = circumference - (percentage / 100) * circumference

    // Calculate marker position for semi-circle
    const angle = (percentage / 100) * Math.PI // This now represents the angle from 0 to π
    const markerX = strokeWidth / 2 + radius * (1 - Math.cos(angle))
    const markerY = size / 2 - radius * Math.sin(angle);

    const [rangeName, setRangeName] = useState("");
    const [rangeColor, setRangeColor] = useState("");

    useEffect(() => {
        let rangeName = colorRanges.find((range) => range.min <= validScore && range.max >= validScore)?.name;
        let rangeColor = colorRanges.find((range) => range.min <= validScore && range.max >= validScore)?.startColor;
        setRangeColor(rangeColor);
        setRangeName(rangeName);
    }, [validScore]);

    return (
        <div className="relative" style={{ width: size, height: size / 2 + strokeWidth / 2 }}>
            <svg
                className="w-full overflow-visible"
                viewBox={`0 0 ${size} ${size / 2 + strokeWidth / 2}`}
            >
                <defs>
                    <linearGradient id="rainbow-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        {colorRanges.map((range, index) => (
                            <React.Fragment key={index}>
                                <stop offset={`${((range.min - 1) / (1000 - 1)) * 100}%`} stopColor={range.startColor} />
                                <stop offset={`${((range.max - 1) / (1000 - 1)) * 100}%`} stopColor={range.endColor} />
                            </React.Fragment>
                        ))}
                    </linearGradient>
                </defs>
                {/* Background path */}
                <path
                    className="text-gray-200"
                    strokeWidth={strokeWidth}
                    stroke="#E1DFE5"
                    fill="transparent"
                    d={`M ${strokeWidth / 2},${size / 2} A ${radius},${radius} 0 0 1 ${size - strokeWidth / 2},${size / 2}`}
                />
                {/* Progress path */}
                <path
                    className="transition-all duration-300 ease-in-out"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    stroke="url(#rainbow-gradient)"
                    fill="transparent"
                    d={`M ${strokeWidth / 2},${size / 2} A ${radius},${radius} 0 0 1 ${size - strokeWidth / 2},${size / 2}`}
                />
                {/* Marker */}

                <circle
                    cx={markerX}
                    cy={markerY}
                    r={strokeWidth / 2}
                    fill="white"
                    stroke="black"
                    strokeWidth="1"
                    className="transition-all duration-300 ease-in-out cursor-pointer"
                />
            </svg>

            {/* Central labels */}
            <div
                className="absolute inset-x-0 top-0 flex flex-col items-center justify-center"
                style={{ height: `${size / 2}px` }}
                aria-live="polite"
                aria-atomic="true"
            >
                <div className="font-bold text-4xl mt-10">{validScore}</div>
                <div className="font-bold text-1xl" style={{ color: rangeColor }}>{rangeName}</div>
            </div>
        </div>
    )
}